module.exports = __webpack_public_path__ + "static/media/boxing-gloves-1.f1ded049.png";